import { createSelector } from '@ngrx/store'
import { UOMState } from '../reducers/uom.reducer'
export const selectUOMList = (state): UOMState => state.equipmentState.uom

export const uomList = createSelector(selectUOMList, status => status.UOMList)
